import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import cartService from '../../../services/cart';
import { setCart } from '../../../slices/cart';
import { CartInStore } from '../../../slices/cart/types';
import {
  getGuaranteeItemsQueryString,
  parseGuaranteeItemsResponse,
} from '../../../utils/cart';

const useGetGuaranteeItems = ({
  cartId,
  lineItemsIds,
}: { cartId?: string; lineItemsIds?: string } = {}) => {
  const dispatch = useDispatch();

  const cart = useSelector((state: { cart: CartInStore }) => state.cart);

  return useQuery({
    queryKey: ['useGetGuaranteeItems', cartId, lineItemsIds],
    queryFn: async () => {
      const { lineItems } = cart;
      try {
        if (!lineItems?.length) {
          const newCartStatus = {
            guaranteeItems: [],
          };
          dispatch(setCart(newCartStatus));
          return [];
        }

        const guaranteeItemsFilterQuery = getGuaranteeItemsQueryString(lineItems);
        const guaranteeItemsResponse =
          await cartService.getGuaranteeItems(guaranteeItemsFilterQuery);

        const getGuaranteeItemsResponse = parseGuaranteeItemsResponse(
          lineItems,
          guaranteeItemsResponse,
        );

        dispatch(
          setCart({
            guaranteeItems: getGuaranteeItemsResponse,
          }),
        );
        return getGuaranteeItemsResponse;
      } catch (error) {
        dispatch(setCart({ guaranteeItems: [] }));
        /* eslint-disable-next-line no-console */
        console.error(error);
        return [];
      }
    },
  });
};

export default useGetGuaranteeItems;
